export default __webpack_public_path__ + "static/media/q20_01.098772ec.png";